import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";

interface Props {
  openDeleteDialog: any;
  setOpenDeleteDialog: React.Dispatch<React.SetStateAction<any>>;
  onDeleteClickHandler: any;
}

export default function DeleteSuggestionsDialog(props: Props) {
  const { openDeleteDialog, setOpenDeleteDialog, onDeleteClickHandler } = props;

  const handleCloseDialog = () => {
    setOpenDeleteDialog({});
  };

  return (
    <>
      {openDeleteDialog.planName && (
        <DialogFormation
          title="Suggested Plan Removal"
          openDialog={openDeleteDialog.planName}
          handleClose={handleCloseDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleCloseDialog} />
              <Button variant="alert" label="Delete" onClick={() => onDeleteClickHandler(openDeleteDialog)} />
            </div>
          }
        >
          <div className="text-center">
            You're about to remove the plan
            <Typography component={"span"} showBold>{` ${openDeleteDialog.planName} `}</Typography>
            from the suggestions. Please confirm your decision before proceeding.
          </div>
        </DialogFormation>
      )}
    </>
  );
}
